import React from "react";

// reactstrap
import { Row } from "reactstrap";

// animations
import Slide from "react-reveal/Slide";
import ModuleTitle from "../ModuleTitle";

// components
import SkillSet from "./components/SkillSet";
import Experience from "./components/Experience";

// api url
import { skillsData, worksData } from "./data";

function Skills() {
  const skillTypes = ["frontend", "backend", "testing"];

  return (
    <div id="skills" className="text-center">
      <div className="skills-container ml-auto mr-auto component-top-margin">
        <ModuleTitle title="SKILLS" />
        <Slide up>
          <Row className="justify-content-center mt-5">
            <SkillSet skillTypes={skillTypes} skills={skillsData} />
            <Experience works={worksData} />
          </Row>
        </Slide>
      </div>
    </div>
  );
}

export default Skills;
